module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_0_1@3x.0759399f.png";